import { render, staticRenderFns } from "./CooperationDecoctingFee.vue?vue&type=template&id=28e5018c"
import script from "./CooperationDecoctingFee.vue?vue&type=script&lang=js"
export * from "./CooperationDecoctingFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28e5018c')) {
      api.createRecord('28e5018c', component.options)
    } else {
      api.reload('28e5018c', component.options)
    }
    module.hot.accept("./CooperationDecoctingFee.vue?vue&type=template&id=28e5018c", function () {
      api.rerender('28e5018c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/manager/pharmacy/Cooperation/CooperationDecoctingFee.vue"
export default component.exports